import { readCalendarItemCard, type CalendarItemCard } from './calendar/calendar-item-card';
import { ownerDisplayTextFor, recordNames } from './owner-display-text';

/** What a card press sends beside its prompt for the owner's bubble alone. The harness drops both before the model reads the row. */
export type ChatRiders = { calendarItem?: CalendarItemCard; displayText?: string };

/**
 * A dashboard widget's `{kind:'chat'}` message as the chat it opens. The prompt (and the widget's context) is
 * what the agent reads. `calendarItem` is the pressed row's card (VMR dashboard `runtime.js` `rowCard`), sent as
 * `references.calendarItem` exactly as a Calendar tap sends it, so the owner's bubble shows the booking rather
 * than an ID prompt. The harness drops that key before the model reads the row, which is why the card may carry
 * names the prompt may not. A card no surface can draw is dropped and the prompt goes alone. `displayText` is this
 * message with the ids the frame sent `names` for swapped for them (`lib/owner-display-text.ts`), shown in the bubble
 * the same way when there is no card. The frame never sends the text itself.
 *
 * One rule on three surfaces: iOS `PageWebView` and Android `DashboardBridge` read the same message the same way.
 */
export function widgetChat(d: { prompt?: unknown; context?: unknown; calendarItem?: unknown; names?: unknown }): {
  message: string;
} & ChatRiders {
  const message = [d.prompt, d.context].filter((part): part is string => typeof part === 'string' && part !== '').join('\n\n');
  const calendarItem = readCalendarItemCard(d.calendarItem);
  const displayText = ownerDisplayTextFor(message, recordNames(d.names));
  return { message, ...(calendarItem ? { calendarItem } : {}), ...(displayText ? { displayText } : {}) };
}
